export { default as DevicesTab } from './DevicesTab';
export { default as HomeTab } from './HomeTab';
export { default as SupportTab } from './SupportTab';



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/tabs/index.ts